export const REFRESH_INTERVAL = 120;
